import { render, staticRenderFns } from "./SanjivaniStudentBulkIcardPrint.vue?vue&type=template&id=f86a2058&scoped=true&"
import script from "./SanjivaniStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SanjivaniStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniStudentBulkIcardPrint.vue?vue&type=style&index=0&id=f86a2058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86a2058",
  null
  
)

export default component.exports